var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"103",
      name:"列详情",
      parentId:"TABLE_ID",
      parentName:"数据实体管理",
      parentPath:"/system/dataBase",
      dataClass:2,
      col:[],
      addBtnClick: _vm.addBtnClick,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }